import LayoutBasic from '../layouts/layoutBasic'
import Link from 'next/link'
import { withRouter } from 'next/router'
import { GET } from '../helpers'
import { ASSET_PROFILE_URL, TOKEN, GET_USER_URL, CART, GET_CONTEST_WINNERS, CONTEST_PHOTOS_URL } from '../vars'
import { setLocalKeyValue, getLocalKeyValue } from '../storage'
import ListPhoto from '../components/listPhoto'
import PhotoListHolder from '../components/photoListHolder'
import moment from 'moment'
import Img from 'react-image'
import { Creator } from './photo'
import PhotographerAvatar from '../components/photographerAvatar'

class ContestsWinners extends React.Component {


  static async getInitialProps(props) {
    let token = await process.browser ? getLocalKeyValue(TOKEN) : props.query.sec_token
    let contest_name = props.query.contest_name
    let infoRequest = {}, infoResponse = {}, contestRequest = {}, contestResponse = {}, allContestRequest = {}, allContestResponse = {}



    try {
      contestRequest = await GET(GET_CONTEST_WINNERS + '?contest_name=' + contest_name)
      contestResponse = await contestRequest.data
    } catch (e) {

    }
    if (token) {
      try {
        infoRequest = await GET(GET_USER_URL, token)
        infoResponse = await infoRequest.data
      } catch (e) {

      }
    }
    return {
      token: token,
      user: infoResponse.user,
      cart: infoResponse.cart,
      likes: infoResponse.likes,
      contest: contestResponse,
      contest_name: contest_name,
    }

  }

  render() {

    let contest_name = this.props.contest_name
    let title = "Picxy Contest Winners| " + contest_name
    let content
    let loader = <div className="image-holder"></div>
    let contest_data = this.props.contest
    if (contest_data.success) {
      let likeIds = []
      if (this.props.likes) {
        likeIds = this.props.likes
      }
      let contest_title = contest_data.title

      let winners_details, special_mentions, winners = "", special_mentions_content
      winners_details = contest_data.winners.map((photo) => {
        const liked = (likeIds.indexOf(photo.id) > -1)
        let photographer = photo.photographer
        // let profile_pic = (photographer.profile_pic && photographer.profile_pic !== "null") ? photographer.profile_pic : 'imgv1/mysteryman.png'
        let photo_genre = ""
        if (contest_name == "IPF_WPD_Contest" || contest_data.genre_p_tags > 1) {
          photo_genre = photo.photo_genre
        }
        return <div className="col-md-3 col-sm-6 mb-4">
          <ListPhoto key={photo.id} photo={photo} liked={liked} reference={this.props.router.asPath} classname_requried={"false"} />
          <div className="mt-2 text-center">
            <Creator photographer={photo.photographer} need_by="no" />
          </div>
          <div className="mt-1 text-center">
            {photo_genre}
          </div>
        </div>
      })
      if (contest_data.speical_mention.length) {
        special_mentions = contest_data.speical_mention.map((photographer) => {
          let photographerName = photographer.first_name + ' ' + photographer.last_name

          if (!photographerName) {
            photographerName = photographer.username
          }

          return <div className="mr-2 mb-2">
            <Link as={`/${photographer.username}`} href={"/?username=" + photographer.username}>
              <a href={`/${photographer.username}`} title={"View photos by " + photographer.username}>
                <PhotographerAvatar profile={photographer.profile} name={photographerName} />
              </a>
            </Link>
          </div>
        })
        special_mentions_content = <div className="mt-3">
          <h2 className="mb-3 text-center">
            <small> Special Mentions </small>
          </h2>
          <div className="row justify-content-center">
            {special_mentions}
          </div>
        </div>
      }
      content = <div className="container mt-4">
        <div className="text-center">
          <h1>
            <small className="text-capitalize">{contest_name}</small>
          </h1>
        </div>
        <div className="mt-3">
          <h2 className="mb-3 text-center">
            <small> Winners </small>
          </h2>
          <div className="row justify-content-center">
            {winners_details}
          </div>
        </div>
        {special_mentions_content}
      </div>
    }
    else {
      content = <div className="container font-small mt-5">
        <div className="text-center mb-5">
          <h1>No Contest found</h1>
        </div>
      </div>
    }
    return <LayoutBasic
      //  title="Picxy Contests"
      title={title} {...this.props} >
      {content}
      <div className="my-4 text-center">
        <Link as={'/contests/entries/' + contest_name} href={"contests/entries/?contest_name=" + contest_name}>
          <a className="btn btn-primary">Check Entries</a>
        </Link>
      </div>
    </LayoutBasic>
  }

}

export default withRouter(ContestsWinners)
